"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidChip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _BaseChip = require("../../../chip/components/BaseChip");
var _chipTheme = require("../../../chip/styled/chipTheme");
var _contactPickerTheme = require("../../contactPickerTheme");
const InvalidChipStyled = (0, _styled.default)(_BaseChip.BaseChip)`
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _contactPickerTheme.contactPickerTheme.option.invalid.text(themeMode);
}}};
    background-color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _contactPickerTheme.contactPickerTheme.option.invalid.background(themeMode);
}};
`;
const InvalidChip = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(InvalidChipStyled, (0, _extends2.default)({}, props, {
    themeMode: themeMode,
    size: _chipTheme.chipTheme.chip.size(themeMode),
    ref: ref
    // This color doesn't matter, we'll override it's colors.
    ,
    color: "red",
    contentBefore: /*#__PURE__*/_react.default.createElement(_lodestarIcons.AlertErrorAltIcon, {
      size: "small",
      role: "presentation",
      color: _contactPickerTheme.contactPickerTheme.option.invalid.icon(themeMode)
    })
  }));
});
exports.InvalidChip = InvalidChip;
InvalidChip.displayName = "InvalidChip";
//# sourceMappingURL=InvalidChip.js.map